<div id="{{appName}}-app" class="first-time-setup-page first-setup-dialog-page row col-12" [ngClass]="{'p-0' : windowWidth <= 768}">
    <div mat-dialog-title class="row col-12">
        <div class="d-flex first-time-setup-page first-setup-dialog-page row col-12 p-0">
            <div class="col-11 p-0">
                <h3 *ngIf="appName==='toyota'" class="first-guide-title">What if I don't complete initial setup of the Toyota app and Audio Multimedia System?
                </h3>
                <h3 *ngIf="appName==='lexus'" class="first-guide-title">
                    WHAT IF I DON'T COMPLETE INITIAL SETUP OF THE LEXUS APP AND LEXUS INTERFACE?

                </h3>
            </div>
            <div class="col-1 p-0">
                <span class="fa fa-close action-icons float-right ml-auto" (click)="close()"></span>
            </div>
        </div>
    </div>
    <div mat-dialog-content>
        <div *ngIf="appName==='toyota'" class="first-time-setup-page first-setup-dialog-page row col-12">
            <div class="first-guide-content">
                <p>
                    If you choose not to download the Toyota app and complete the initial setup described in this quick start guide, your Audio
                    Multimedia System will be set to “Guest Mode.” This means your personalized settings will not automatically
                    load when you start your vehicle.
                </p>
                <p>In addition, you will not be able to use your available trials or paid subscriptions for Connected Services
                    by Toyota.
                </p>
                <p>
                    If you wish to enjoy these benefits, please return to the quick start guide to complete the setup. </p>
                <div class="row col-12">
                    <div class="col-6" [ngClass]="{'col-12' : windowWidth <= 768}">
                        <app-image-video-carousel [fromFirstGuide]=true [startIndex]="0" [carouselContainerWidth]="250" [superSlides]="guestModedImage"></app-image-video-carousel>
                    </div>

                    <div class="col-6" [ngClass]="{'col-12' : windowWidth <= 768}">
                        <app-image-video-carousel [fromFirstGuide]=true [startIndex]="0" [carouselContainerWidth]="250" [superSlides]="navigationImage"></app-image-video-carousel>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="appName==='lexus'" class="first-time-setup-page first-setup-dialog-page row col-12">
            <div class="first-guide-content">
                <p class="first-guide-content">
                    If you choose not to download the Lexus app and complete the initial setup described in this quick start guide, your Lexus
                    Interface will be set to “Guest Mode.” This means your personalized settings will not automatically load
                    when you start your vehicle.
                </p>
                <p class="first-guide-content">In addition, you will not be able to use your available trials or paid subscriptions for Interface Services
                    by Lexus.
                </p>
                <p class="first-guide-content">
                    If you wish to enjoy these benefits, please return to the quick start guide to complete the setup.
                </p>

                <div class="row col-12">
                    <div class="col-6" [ngClass]="{'col-12' : windowWidth <= 768}">
                        <app-image-video-carousel [fromFirstGuide]=true [startIndex]="0" [carouselContainerWidth]="250" [superSlides]="guestModedImage"></app-image-video-carousel>
                    </div>
                    <div class="col-6" [ngClass]="{'col-12' : windowWidth <= 768}">
                        <app-image-video-carousel [fromFirstGuide]=true [startIndex]="0" [carouselContainerWidth]="250" [superSlides]="navigationImage"></app-image-video-carousel>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>